module.exports = __webpack_public_path__ + "img/cary-help.7c47d6c5.png";